import { useEffect, useState } from "react";
import { checkStoreStatus } from "../utils/storeStatus";
import type { StoreStatus } from "../types";

/** Status da loja, reavaliado a cada 30s (mesmo intervalo da versão anterior). */
export const useStoreStatus = (): StoreStatus => {
  const [status, setStatus] = useState<StoreStatus>(checkStoreStatus);

  useEffect(() => {
    const intervalo = setInterval(() => {
      setStatus(checkStoreStatus());
    }, 30000);
    return () => clearInterval(intervalo);
  }, []);

  return status;
};
